import api from "../axios";

export const getDriverAttendanceApi = (
    branchid: string,
    openingKM: string
) => {
    return api.get(`/booking/getdriverattandance`, {
        params: { branchid, openingKM }
    });
};

//approveattandance
export const approveAttendanceApi = (
    cabid: string,
    openingKM: string,
    employeename: string
) => {
    return api.post(`/booking/approveattandance`, {
        cabid,
        openingKM,
        employeename
    });
};

//logout 
export const approveLogoutApi = (
    cabid: string,
    closingKM: string,
    employeename: string
) => {
    return api.post(`/booking/approvelogout`, {
        cabid,
        closingKM,
        employeename
    });
};

//leave approve
export const leaveApproveApi = (
    cabid: string,
    reason: string,
    fromdate: string,
    todate: string
) => {
    return api.post(`/booking/leaveapprove`, {
        cabid,
        reason,
        fromdate,
        todate
    });
};

//revertlogin
export const revertLoginApi = (
    cabid: string,
    employeename: string
) => {
    return api.post(`/booking/revertlogin`, {
        cabid,
        employeename
    });
};

//revertlogout
export const revertLogoutApi = (
    cabid: string,
    employeename: string
) => {
    return api.post(`/booking/revertlogout`, {
        cabid,
        employeename
    });
};

//getlogoutdetails
export const getLogoutDetailsApi = (cabid: string) => {
    return api.get(`/booking/getlogoutdetails`, {
        params: { cabid }
    });
};

// holdduty
export const holdDutyApi = (
    cabid: string,
    employeename: string,
    reason: string
) => {
    return api.post(`/booking/Holdduty`, {
        cabid,
        employeename,
        reason,
    });
};

// release hold duty
export const releaseHoldCabApi = (
    cabid: string,
    employeename: string
) => {
    return api.post(`/booking/releaseholdcab`, {
        cabid,
        employeename
    });
};

// resume duty
export const resumeDutyCabApi = (
    cabid: string,
    employeename: string
) => {
    return api.post(`/booking/Resumedutycab`, {
        cabid,
        employeename
    });
};

// edit driver location
export const editDriverLocationApi = (
    cabid: string,
    piclat: string,
    piclon: string,
    present_location: string,
    locationupdatedby: string
) => {
    return api.post(`/booking/editdriverlocation`, {
        cabid,
        piclat,
        piclon,
        present_location,
        locationupdatedby
    });
};

//make cab available
export const makeCabAvailableApi = (cabid: string) => {
    return api.post(`/booking/makeCabAvailable`, {
        cabid
    }, {
        params: { cabid }
    });
};